import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box, Button,
    Checkbox,
    Flex,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Radio, RadioGroup,
    Select,
    Table, Tbody,
    Td,
    Text, Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import { useMemo, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useUpdateAdspressoAdCaroByAdIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_Awareness_Traffic_Engagement,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { removeEmptyValues, truncateString } from 'utils/functions';
import { object, string } from "yup";
import UrlParametersUpdate from '../UrlParametersUpdate';
import BuildUrlParamsUpdate from '../BuildUrlParamsUpdate';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';
import { MdOutlineEdit } from 'react-icons/md';

let schema = object().shape({
    type: string()
        .required('Type is required'),
    message: string(),
    link: string()
        .url('Please add a valid URL')
        .when('destinationType', {
            is: (value) => !['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(value),
            then: () => string().required('Link is required'),
            otherwise: () => string().notRequired(),
        }),
    // phoneNumber: string().
    //     when('type', {
    //         is: 'CALL_NOW',
    //         then: () => string()
    //         .transform((value) => {
    //             if (typeof value === 'string') {
    //                 return value.replace(/^tel:\+?/, ''); // Removes "tel:" and "+" if present
    //             }
    //             return value;
    //         })
    //         .matches(/^[0-9]{10,15}$/, 'Phone number must be between 10 and 15 digits')
    //         .required('Phone number is required'),
    //         otherwise: () => string().notRequired(),
    //     })
    //     .min(10, 'Phone number is too short')
    //     .max(15, 'Phone number is too long'),
})


const CaroAdUpdateForm = ({ adData, creative, adAccount, objective }) => {

    const toast = useToast();
    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const boxBorder = useColorModeValue("gray.200", "gray.700");

    const { link, message, name, type, url_tags, _id, contextual_multi_ads, fileName, asset_feed_spec, caption, template_url_spec, adsAccount, page_welcome_message } = creative || {}

    const destinationType = creative?.adsets[0]?.destination_type;
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();
    const [updateAdspressoCarocreativeAds, { isLoading: isAdspressoCaroAdUpdating }] = useUpdateAdspressoAdCaroByAdIdMutation({});
    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adsAccount?.adsAccountId}, {skip: !adsAccount?.adsAccountId});

    const formattedPageIds = useMemo(() => {
        if (!adData?.adsAccounts?.length || !adAccount?.adsAccountId) return [];

        const matchedAccount = adData.adsAccounts.find(
            acc => acc.adsAccountId === adAccount.adsAccountId
        );

        return matchedAccount?.page_id ? [matchedAccount.page_id] : [];
    }, [adData, adAccount]);

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || destinationType !== 'ON_AD' }
    );

    const caroMediaFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: name || '',
            message: message || '',
            type: type || '',
            link: link || '',
            caption: caption || '',
            url_tags: url_tags || '',
            phoneNumber: link?.includes('tel:+') ? link.replace('tel:+', '') : '',
            fileName: fileName || '',
            enroll_status: contextual_multi_ads?.enroll_status ? contextual_multi_ads?.enroll_status : 'OPT_OUT',
            app_product_page_id: asset_feed_spec?.app_product_page_id,
            app_id: template_url_spec?.config?.app_id || '',
            page_welcome_message: page_welcome_message,
            destinationType: destinationType,
        },
        validationSchema: schema,
        onSubmit: (values, { resetForm }) => {
            const { link, message, name, type, url_tags, fileName, enroll_status, app_product_page_id, caption, app_id, phoneNumber, page_welcome_message } = values;

            const initialPayload = {
                name,
                fileName,
                contextual_multi_ads: {
                    enroll_status,
                },
                asset_feed_spec: {
                    app_product_page_id,
                },
                message,
                type,
                ...(["OUTCOME_AWARENESS","OUTCOME_TRAFFIC","OUTCOME_ENGAGEMENT"].includes(objective) && {
                    ...(type !== 'CALL_NOW' && {caption}),
                }),
                ...(objective === "OUTCOME_AWARENESS" && {
                    template_url_spec: { config: { app_id } },
                }),
                // degrees_of_freedom_spec: {
                //     creative_features_spec: {
                //       standard_enhancements: { enroll_status: "OPT_OUT" },
                //     },
                // },
                ...((['WHATSAPP'].includes(destinationType)) && { page_welcome_message }),
                ...(url_tags?.trim() && { url_tags }),
                ...(link && { link: link }),
                ...(phoneNumber && type === 'CALL_NOW' && { link : `tel:+${phoneNumber}`})
            };

            const payload = removeEmptyValues(initialPayload);

            try {
                updateAdspressoCarocreativeAds({ _id, payload }).unwrap()
                    .then(response => {
                        toast({
                            position: "top-right",
                            title: "Ad updated",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                        });
                    })
                    .catch(error => {
                        const errorMessage = error?.data?.message || "An unexpected error occurred";
                        const formattedMessage = errorMessage.replace(/['"]/g, '');

                        toast({
                            position: "top-right",
                            title: "Error updating Ad",
                            description: formattedMessage,
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                        });
                    });
            } catch (error) {
                // console.log(error);

            } finally {
                resetForm();
            }
        }
    });

    const handleUrlChange = (constructedUrl) => {
        caroMediaFormik.setFieldValue('link', constructedUrl);
    };
    
    const handleUrlParamChange = (constructedUrl) => {
        caroMediaFormik.setFieldValue('url_tags', constructedUrl);
    };

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === formattedPageIds[0]);

    return (
        <>
            <Flex py={2} direction={'column'} gap={2}>
                <Flex direction="column">
                    {Boolean(adData?.useFileName) ? (
                        <Flex mb={4} direction="column">
                            <Flex alignItems="center" mb={2} gap={2}>
                                <Text fontSize={'14px'} fontWeight="bold">Ad name</Text>
                            </Flex>
                            <Input
                                placeholder="Ad name"
                                name="fileName"
                                size={'sm'}
                                borderRadius="md"
                                value={caroMediaFormik.values.fileName}
                                onChange={caroMediaFormik.handleChange}
                            />
                        </Flex>
                    ) : null}
                    {/* Multi-advertiser ads Section */}
                    <Flex direction="column" mb={4} borderRadius="md" gap={2}>
                        <Checkbox
                            onChange={(e) => {
                                caroMediaFormik.setFieldValue("enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                            }}
                            colorScheme="brand"
                            isChecked={caroMediaFormik.values.enroll_status === 'OPT_IN'}
                        >
                            <Flex align={'center'}>
                                <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="12px" p="5px">
                                            <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Checkbox>
                    </Flex>

                    <Flex alignItems="center" mb={2} gap={2}>
                        <Text fontSize="14px" fontWeight="bold">Primary text</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        The primary text for your ad appears in most placements, though the position
                                        varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                                        characters or less.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" />
                        </Tooltip>
                    </Flex>
                    <Textarea
                        placeholder="Tell people what your ad is about..."
                        name="message"
                        size={'sm'}
                        borderRadius="md"
                        value={caroMediaFormik.values.message}
                        onChange={caroMediaFormik.handleChange}
                    />
                </Flex>
                {caroMediaFormik.values.type !== 'CALL_NOW' ? (
                    <Box direction="column">
                        <Flex alignItems="center" mb={2} gap={2}>
                            <Text fontWeight="bold" fontSize={'14px'}>Call to action</Text>
                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Box fontSize="12px" p="5px">
                                        <Text>Show a button or link on your ad that represents the action you want people to take.</Text>
                                    </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>
                        <Select
                            name="type"
                            borderRadius={'md'}
                            value={caroMediaFormik.values.type}
                            onChange={caroMediaFormik.handleChange}
                            size={'sm'}
                            isDisabled={(destinationType === 'WHATSAPP' && objective === 'OUTCOME_LEADS')}
                        >
                            {destinationType === 'ON_AD' ? (
                                <>
                                    {call_to_action_options_instantForms?.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </>
                             ) : destinationType === 'APP' && objective === 'OUTCOME_APP_PROMOTION' ? (
                                <>
                                    {call_to_action_options_app_promptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </>
                            ) : destinationType === 'APP' && ['OUTCOME_SALES', 'OUTCOME_LEADS'].includes(objective) ? (
                                <>
                                    {call_to_action_options_for_app_leads_and_sales.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </>
                            ) : destinationType === 'WHATSAPP' ? (
                                <>
                                    {call_to_action_options_whatsapp.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </>
                            ) : objective === 'OUTCOME_AWARENESS' || (['OUTCOME_TRAFFIC', 'OUTCOME_ENGAGEMENT'].includes(objective) && destinationType === 'WEBSITE' )  ? (
                                <>
                                {call_to_action_options_Awareness_Traffic_Engagement?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                                </>
                            ) :
                                <>
                                    {call_to_action_options.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </>
                            }
                        </Select>
                    </Box>
                ) : null}


                {/* {caroMediaFormik.values.type === 'CALL_NOW' ? (
                    <>
                        <Box>
                            <Flex alignItems="center" mt={'10px'} mb={2}>
                                <Text fontWeight="bold" fontSize={'14px'}>Call now</Text>
                                <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="sm" p="5px">
                                        <Text>You can use a different phone number for each carousel card. This can be helpful if you have different phone numbers or extensions.</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <PhoneInput
                                    country={'in'}
                                    value={caroMediaFormik.values.phoneNumber}
                                    onChange={(value) => {
                                        caroMediaFormik.setFieldValue('phoneNumber', value)
                                    }}
                                    inputProps={{
                                        name: 'phoneNumber',
                                        required: true,
                                        autoFocus: true,
                                    }}
                                    enableSearch={true}
                                    searchPlaceholder="Search"
                                />

                            {caroMediaFormik.touched.phoneNumber && caroMediaFormik.errors.phoneNumber ? (
                                <Text color="red.500" fontSize={'12px'}>{caroMediaFormik.errors.phoneNumber}</Text>
                            ) : null}
                        </Box>
                    </>
                ) : null} */}


                {destinationType === 'WEBSITE' || objective === 'OUTCOME_AWARENESS' ? (
                    <>
                        <Flex direction="column">
                            <Flex alignItems="center" gap={2} mb={'10px'}>
                                <Text fontWeight="bold" fontSize={'14px'}>Website URL</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="12px" p="5px">
                                            <Text>Enter the URL for the webpage you want people to visit</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Flex direction={'column'} gap={1}>
                                <Input
                                    type="url"
                                    name="link"
                                    borderRadius={'md'}
                                    placeholder="Enter URL"
                                    value={caroMediaFormik.values.link}
                                    onChange={caroMediaFormik.handleChange}
                                    size={'sm'}
                                />
                                {caroMediaFormik.touched.link && caroMediaFormik.errors.link ? (
                                    <Text color="red.500" fontSize={'12px'}>{caroMediaFormik.errors.link}</Text>
                                ) : null}
                            </Flex>
                        </Flex>
                    </>
                ) : null}

                {destinationType === 'APP' && objective === 'OUTCOME_APP_PROMOTION' ? (
                    <>
                        <Flex direction="column" gap={2}>
                            <Flex alignItems="center" gap={2}>
                                <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="12px" p="5px">
                                            <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                            <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                            <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                            <Box>
                                                <Text>* Android app link</Text>
                                                <Text>* Custom URL scheme</Text>
                                                <Text>* Facebook app link</Text>
                                            </Box>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Input
                                type="url"
                                name="link"
                                borderRadius={'md'}
                                placeholder="Enter URL"
                                value={caroMediaFormik.values.link}
                                onChange={caroMediaFormik.handleChange}
                                size={'sm'}
                            />
                        </Flex>

                        <Flex direction="column" gap={2}>
                            <Flex alignItems="center" gap={2}>
                                <Text fontWeight="bold" fontSize="14px">Custom store listing</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="12px" p="5px">
                                            <Text fontWeight="bold">Using a custom store listing</Text><br />
                                            <Text mb={2}>A custom store listing ID sends people to a landing page you've customized...</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Input
                                placeholder="Enter custom store listing ID"
                                name="app_product_page_id"
                                size={'sm'}
                                borderRadius="md"
                                value={caroMediaFormik.values.app_product_page_id}
                                onChange={caroMediaFormik.handleChange}
                            />
                        </Flex>
                    </>
                ) : null}

                {destinationType === 'APP' && ['OUTCOME_SALES', 'OUTCOME_LEADS'].includes(objective) ? (
                    <>
                        <Flex mb={4} direction="column" gap={2}>
                            <Flex alignItems="center" gap={2}>
                                <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="12px" p="5px">
                                            <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Input
                                type="url"
                                name="link"
                                borderRadius={'md'}
                                placeholder="Enter the deep link URL"
                                value={caroMediaFormik.values.link}
                                onChange={caroMediaFormik.handleChange}
                                size={'sm'}
                            />
                        </Flex>
                    </>
                ) : null}

                {destinationType === 'ON_AD' ? (
                    <>
                        <Flex alignItems="center" gap={2} mt={2}>
                            <Text fontWeight="bold">Instant form</Text>
                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Box fontSize="12px" p="5px">
                                        <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                    </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>

                        {/* Table Layout */}
                        {filteredInstantForms?.length > 0 ? (
                            <RadioGroup onChange={(value) => caroMediaFormik.setFieldValue('link', value)} value={caroMediaFormik.values.link} colorScheme="brand">
                                <Table variant="simple">
                                    <Thead>
                                        <Tr>
                                            <Th textTransform={'none'} color={'none'} fontSize="14px">Form title</Th>
                                            <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {filteredInstantForms?.map((form) => (
                                            <Tr key={form?.id}>
                                                <Td>
                                                    <Flex alignItems="center" gap={2}>
                                                        <Radio value={form?.id} />
                                                        <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                            {truncateString(form?.name, 25)}
                                                        </Text>
                                                    </Flex>
                                                </Td>
                                                <Td>
                                                    <Text fontSize={'12px'}>
                                                        {new Date(form?.created_time).getFullYear()}-
                                                        {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                        {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                    </Text>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </RadioGroup>
                        ) : (
                            <Text fontSize="14px" color="gray.500">No form data available</Text>
                        )}
                    </>
                ) : null}

                {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT"].includes(objective) && destinationType !== 'PHONE_CALL' ? 
                    <Flex direction="column" gap={2} mb={4}>
                        <Text fontWeight="bold" fontSize={'14px'}>Display link</Text>
                        <Input
                            name="caption"
                            placeholder="Enter the link that you want to show on your ad"
                            bg="#fff"
                            size='sm'
                            borderRadius="md"
                            value={caroMediaFormik.values.caption}
                            onChange={caroMediaFormik.handleChange}
                        />
                    </Flex>
                : null}

                {objective === "OUTCOME_AWARENESS" ? 
                        <Flex direction={'column'} gap={1} mb={4}>
                            <Flex alignItems="center" gap={2} mb={'5px'}>
                                <Text fontWeight="bold" fontSize={'14px'}>Mobile app</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="12px" p="5px">
                                            <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Select
                                name={`app_id`}
                                bg="#fff"
                                size="sm"
                                borderRadius="md"
                                onChange={caroMediaFormik.handleChange}
                                onBlur={caroMediaFormik.handleBlur}
                                value={caroMediaFormik?.values?.app_id}
                            >
                                <option value="">Choose app</option>
                                {advertisableApps?.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </Select>
                        </Flex>
                :null}

                {['WHATSAPP'].includes(destinationType) ? (
                    <>
                        <Flex mb={2}>
                            <Text fontWeight={'bold'} fontSize={'sm'}>Message template</Text>
                        </Flex>
                    
                        {(() => {
                        const welcomeData = caroMediaFormik?.values?.page_welcome_message;

                        const type = welcomeData?.text_format?.customer_action_type;

                        const greeting = welcomeData?.text_format?.message?.text || '';
                        const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                        const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                        return (
                            <Box mb={2}>
                                <Box border={'1px solid'} borderColor={boxBorder} p={2} borderRadius={'md'} bg={backgroundColor}>
                                    <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                    {type === 'autofill_message' && (
                                        <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                    )}

                                    {type === 'ice_breakers' && (
                                        <>
                                        <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                        {iceBreakers.map((q, i) => (
                                            <Text key={i} fontSize="14px">
                                            {i + 1}. {q.title}
                                            </Text>
                                        ))}
                                        </>
                                    )}
                                </Box>

                                <Button
                                    variant="outline"
                                    backgroundColor="transparent" 
                                    size={'sm'}
                                    leftIcon={<MdOutlineEdit />}
                                    mt={2}
                                    onClick={() => {
                                        onMessageModalOpen();
                                    }}
                                >
                                    Edit
                                </Button>
                            </Box>
                        );
                        })()}
                    </>
                ) : null}

                {['APP', 'PHONE_CALL', 'WHATSAPP'].includes(destinationType) ? null :
                    <Flex direction="column" gap={1}>
                        <Flex alignItems={'center'} gap={2}>
                            <Text fontWeight="bold" fontSize={'14px'}>
                                URL parameters{" "}
                                {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                            </Text>
                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Box fontSize="12px" p={'5px'}>
                                        <Text >
                                            Add parameters to the end of your website URL to track where your visitors are coming from.
                                        </Text>
                                    </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>
                        <Input
                            name="url_tags"
                            placeholder="key1=value1&key2=value2"
                            bg="#fff"
                            size='sm'
                            borderRadius="md"
                            value={caroMediaFormik.values.url_tags}
                            onChange={caroMediaFormik.handleChange}
                        />
                        <Flex mt={1}>
                            <Button onClick={() => {
                                setUrlParamModalOpen(true)
                            }}
                                variant="link"
                                color='brand'>
                                <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                            </Button>
                        </Flex>
                        {caroMediaFormik.touched?.url_tags && caroMediaFormik.errors?.url_tags && (
                            <Text fontSize={"12px"} color="red.500">{caroMediaFormik.errors?.url_tags}</Text>
                        )}
                    </Flex>
                }

                <Flex justifyContent="flex-start" mt={'5px'}>
                    <Button
                        colorScheme="brand"
                        onClick={() => caroMediaFormik.handleSubmit()}
                        size={'sm'}
                        isLoading={isAdspressoCaroAdUpdating}
                        isDisabled={isAdspressoCaroAdUpdating}
                    >
                        Save
                    </Button>
                </Flex>
            </Flex>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={caroMediaFormik.values.page_welcome_message}
                onSave={(updatedData) => {
                    caroMediaFormik.setFieldValue('page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={caroMediaFormik?.values} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={caroMediaFormik?.values} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default CaroAdUpdateForm;